import Panel from 'components/Panel';
import React from 'react';
import ReferenceItems from './ReferenceItems';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';
import {usePartnersRefs} from 'redux/partners/hooks/usePartnersRefs';
import {
   NO_PARTNER_REFS,
   NO_SYNC_REFS,
   NO_TRANS_REFS,
   partnerRefLabel,
   PROXY_REFERENCE_TITLE,
   PROXY_SERVER,
   syncRefLabel,
   transRefLabel,
} from 'common/strings';
import {useSynchronizationsRefs} from 'redux/synchronizations/hooks/useSynchronizationsRefs';

const ProxyReferencesPanel = ({id}: {id: string}) => {
   const transactions = useTransactionsRefs(id, 'proxy');
   const synchronizations = useSynchronizationsRefs(id, 'proxy');
   const partners = usePartnersRefs(id, 'proxy');

   return (
      <Panel name={PROXY_REFERENCE_TITLE}>
         <ReferenceItems
            name={partnerRefLabel(PROXY_SERVER)}
            data={partners}
            noData={NO_PARTNER_REFS}
         />
         <ReferenceItems
            name={transRefLabel(PROXY_SERVER)}
            data={transactions}
            noData={NO_TRANS_REFS}
         />
         <ReferenceItems
            name={syncRefLabel(PROXY_SERVER)}
            data={synchronizations}
            noData={NO_SYNC_REFS}
         />
      </Panel>
   );
};

export default ProxyReferencesPanel;
